import { render } from "./HalamanTabelStruktur.vue?vue&type=template&id=31e5d1b0&scoped=true"
import script from "./HalamanTabelStruktur.vue?vue&type=script&lang=js"
export * from "./HalamanTabelStruktur.vue?vue&type=script&lang=js"

import "./HalamanTabelStruktur.vue?vue&type=style&index=0&id=31e5d1b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e5d1b0"]])

export default __exports__